import React from 'react';
import { Link } from 'gatsby';
import '../styles/browselink.scss';

function BrowseLink() {
    return <Link to="#">browse</Link>;
}

export default BrowseLink;
